import React from 'react'

const CommunityMembersList = ({
  members = [],
  selectedUser,
  onSelectUser
}) => (
  <div className="member-list">
    {(Array.isArray(members) ? members : []).map((member, idx, arr) => {
      const memberId = member?._id || member?.id
      const isSelected =
        selectedUser &&
        (selectedUser._id === member?._id || selectedUser.id === member?.id)
      return (
        <React.Fragment key={memberId}>
          <div
            className={`member-list-item${isSelected ? ' selected' : ''}`}
            onClick={() => onSelectUser?.(member)}
            style={{ cursor: 'pointer' }}
          >
            {member?.name || member?.username || 'Unnamed'}
          </div>
          {idx < arr.length - 1 && (
            <div className="member-divider" />
          )}
        </React.Fragment>
      )
    })}
  </div>
)

export default CommunityMembersList
